import * as React from 'react';
import { ImageField, ImageInput, FileField, FileInput, useRecordContext } from 'react-admin';
import { getThumborPic } from '../../global';

export const UpLoadFile = (props) => {
    const record = useRecordContext();
    
    if (props.notImg) {
        return (
            <FileInput {...props} accept="*">
                <FileField source={props.source} title="文件" />
            </FileInput>
        );
    }

    return (
        <ImageInput {...props} accept="image/*">
            <ImageField source={props.source} title="预览" />
        </ImageInput>
    );
};

export const CurrentImage = (props) => {
    const { source, label } = props;
    const record = useRecordContext();
    
    if (!record || !record[source]) return null;
    
    return (
        <div style={{ marginBottom: 8 }}>
            <img 
                src={getThumborPic(record[source], 120, 120)} 
                alt={label} 
                style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 4, border: '1px solid #ddd' }} 
            />
            <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>当前图片</div>
        </div>
    );
};

export const PreviewImage = (props) => {
    let { record, source, label, picResize } = props;
    if (typeof record == "string") {
        record = { [source]: record };
    }

    if (picResize && record[source]) {
        let _imgPath = getThumborPic(record[source], 60, 60);
        return <div><img src={_imgPath} alt={label} style={{ width: 60, height: 60, objectFit: 'cover' }} /></div>;
    }

    return <ImageField {...props} label={label} record={record} source={source} />;
};

export const FirstImageField = (props) => {
    let { record, source, label, picResize } = props;
    let imgPath = '';
    
    if (!record) return null;
    
    const imgValue = record[source];
    
    if (typeof imgValue === 'string') {
        imgPath = imgValue;
    } else if (Array.isArray(imgValue) && imgValue.length > 0) {
        imgPath = imgValue[0];
    }
    
    if (!imgPath) return null;
    
    if (picResize) {
        imgPath = getThumborPic(imgPath, 60, 60);
    }
    
    return (
        <div>
            <img 
                src={imgPath} 
                alt={label} 
                style={{ width: 60, height: 60, objectFit: 'cover', cursor: 'pointer' }} 
            />
        </div>
    );
};